export default "__VITE_ASSET__C7EVQd5v__"